<template>
  <div>

    <h2 v-if="isEditing">Update your application</h2>
    <h2 v-else>Create an application</h2>

    <p>
      An application describes the settings associated with an API key to access
      our APIs.
    </p>

    <b-form action="" method="post" novalidate class="create-form" v-on:submit.prevent="isEditing ? updateApp : createApp">
      <div class="form-group">
        <label>Name*</label>
        <b-input
          id="name"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="A user-friendly identifier for your application"
          v-model="name"
          name="name"
          @keydown.enter="keyEnter"
        ></b-input>
        <div class="invalid-feedback">
          Please provide a valid name.
        </div>
      </div>
      <!-- form-group// -->

      <div class="form-group">
        <label>Description</label>
        <b-form-textarea
          name="description"
          v-model="description"
          placeholder="(optional) additional information about the application"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <div class="invalid-feedback"></div>
      </div>

      <div class="form-group">
        <b-form-checkbox
            v-model="is_default"
            name="is_default"
            :disabled='this.is_default === true'
            switch>
              Make the default app (ie. the app which will be used when no API key is specified such as via a web interface.
        </b-form-checkbox>
      </div>
      <!-- form-group// -->

      <!--
        <h4 class="mt-3">Capabilities</h4>
      <p>
        Turn on capabilities that you want to use with this application. You can
        add and remove capabilities at any time.
      </p>

      <div>
        <b-card-group deck>
          <b-card>
            <b-card-text>
              <b-form-checkbox v-model="app.config.stt" name="stt" switch>
                <b>Speech to text</b></b-form-checkbox
              >
              <p>
                Transcribe speech from audio or video files to text. Supports
                realtime streaming and bulk archive.
              </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-text>
              <b-form-checkbox v-model="app.config.mt" name="mt" switch>
                <b>Machine translation</b></b-form-checkbox
              >
              <p>
                Convert text in files from one of 30 languages to another.
              </p>
            </b-card-text>
          </b-card>
        </b-card-group>
      </div>

      <div class="mt-4">
        <b-card-group deck>
          <b-card>
            <b-card-text>
              <b-form-checkbox v-model="app.config.blah" name="check-button" switch>
                <b>Alignment</b></b-form-checkbox
              >
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
            </b-card-text>
          </b-card>
          <b-card>
            <b-card-text>
              <b-form-checkbox v-model="app.config.blah" name="check-button" switch>
                <b>Product D</b></b-form-checkbox
              >
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
            </b-card-text>
          </b-card>
        </b-card-group>
      </div> -->

      <div class="mt-4 text-right">
        <b-button
          type="button"
          variant="outline-secondary"
          @click.prevent="onCancel"
          class="mx-3"
          >CANCEL</b-button
        >
        <b-button type="button" variant="primary" :disabled="!canCreate" v-if="!isEditing" @click.prevent="createApp">
          CREATE
        </b-button>
        <b-button type="button" variant="primary" :disabled="!canUpdate" v-if="isEditing" @click.prevent="updateApp">
          UPDATE
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_crm.js'

// const apiClient = require('@/services/api_client_crm.js')
export default {
  props: {
    id: {
      type: String
      // default: null
    }
  },
  data () {
    return {
      name_: '',
      description_: '',
      is_default_: false
    }
  },
  methods: {
    keyEnter () {
      if (this.isEditing) {
        return this.updateApp()
      }
      return this.createApp()
    },
    createApp () {
      if (!this.canCreate) {
        return
      }
      apiClient.post('/api/apps', {
        name: this.name,
        description: this.description,
        is_default: this.is_default
      }).then((response) => {
        this.alertType = 'success'
        this.alertText = 'Application created and API key generated'
        this.alertVisible = true
        // If we just added the 'default' app, then ensure it's the only one
        if (this.is_default === true) {
          this.$store.state.user.apps.forEach(x => {
            x.is_default = false
            console.log(x.name)
          })
        }
        // Append to store
        this.$store.commit('ADD_APP', response.data)
        this.$router.push('/apps')
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data) // => the response payload
        }
      })
    },
    updateApp () {
      if (!this.canUpdate) {
        return
      }
      apiClient.patch(`/api/apps/${this.$route.params.id}`, {
        name: this.name,
        description: this.description,
        is_default: this.is_default
      }).then((response) => {
        this.alertType = 'success'
        this.alertText = 'Changes saved'
        this.alertVisible = true
        // If we just set the app to 'default', then ensure it's the only one
        if (this.is_default === true) {
          this.$store.state.user.apps.filter(x => x.id !== this.currentApp.id).forEach(x => {
            x.is_default = false
            console.log(x.name)
          })
        }
        // Now update the item
        this.$router.push('/apps')
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data) // => the response payload
        }
      })
    },
    onCancel () {
      this.$router.push('/apps')
    }
  },
  computed: {
    isEditing () {
      // params could be {'id': 'new'} or {'id': <uuid>}
      return 'id' in this.$route.params && this.$route.params.id && this.$route.params.id !== 'new'
    },
    canCreate () {
      return this.name && this.name.length > 1
    },
    canUpdate () {
      // const modified = this.currentApp.name !== this.name || this.currentApp.description !== this.description
      return this.name && this.name.length > 1
    },
    currentApp () {
      if (this.isEditing) {
        return this.$store.state.user.apps.filter(x => x.id === this.$route.params.id)[0]
      } else {
        return null
      }
    },
    siblingApps () {
      if (this.isEditing) {
        const siblings = this.$store.state.user.apps.filter(x => x.id !== this.$route.params.id)
        console.log(`siblings: ${siblings}`)
        return siblings
      } else {
        return this.$store.state.user.apps
      }
    },
    name: {
      get () {
        if (this.isEditing) {
          return (this.currentApp) ? this.currentApp.name : ''
        } else {
          return this.name_
        }
      },
      set (value) {
        if (this.isEditing) {
          this.currentApp.name = value
        } else {
          this.name_ = value
        }
      }
    },
    description: {
      get () {
        if (this.isEditing) {
          return (this.currentApp) ? this.currentApp.description : ''
        } else {
          return this.description_
        }
      },
      set (value) {
        if (this.isEditing) {
          this.currentApp.description = value
        } else {
          this.description_ = value
        }
      }
    },
    is_default: {
      get () {
        if (this.isEditing) {
          return (this.currentApp) ? this.currentApp.is_default : false
        } else {
          return this.is_default_
        }
      },
      set (value) {
        if (this.isEditing) {
          this.currentApp.is_default = value
        } else {
          this.is_default_ = value
        }
      }
    }
  }
}
</script>

<style scoped></style>
